var map = {
	"./zp-s1-0.png": 6195,
	"./zp-s1-1.png": 5434,
	"./zp-s1-10.png": 592,
	"./zp-s1-2.png": 4417,
	"./zp-s1-3.png": 1704,
	"./zp-s1-4.png": 1319,
	"./zp-s1-5.png": 7678,
	"./zp-s1-6.png": 101,
	"./zp-s1-7.png": 2588,
	"./zp-s1-8.png": 2891,
	"./zp-s1-9.png": 9234,
	"./zp-s1-bonus.png": 6646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6223;